// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
export type PackageVersionStatus_DesignPackageFragment = { __typename?: 'DesignPackage', id: string, availableUpdates: Array<{ __typename?: 'DesignPackagePlanUpdate', id: string, planVersion: { __typename?: 'ReadyPlanAggregateVersion', id: string, readyPlan:
        | { __typename?: 'ReadyPlan', id: string }
        | { __typename?: 'PlanPackage', id: string }
        | { __typename?: 'DesignPackage', id: string }
        | { __typename?: 'ProductOffering', id: string }
       } }> };

export const PackageVersionStatus_DesignPackageFragmentDoc = gql`
    fragment PackageVersionStatus_DesignPackage on DesignPackage {
  id
  availableUpdates {
    id
    planVersion {
      id
      readyPlan {
        id
      }
    }
  }
}
    `;